import { Trainer } from '../dao/core-dao'
import React, { ReactNode, createContext, useCallback, useContext, useState } from 'react'

type TrainerModalContextValue = {
  openTrainerId: string | null
  trainerFromContext: Trainer | undefined
  openTrainer: (trainerId: string, trainer?: Trainer) => void
  closeTrainer: () => void
}

const TrainerModalContext = createContext<TrainerModalContextValue | null>(null)

export const useTrainerModalContext = (): TrainerModalContextValue => {
  const context = useContext(TrainerModalContext)
  if (!context) throw new Error('useTrainerModalContext must be used within TrainerModalContextProvider')
  return context
}

export const TrainerModalContextProvider = ({ children }: { children: ReactNode }): React.ReactElement => {
  const [openTrainerId, setOpenTrainerId] = useState<string | null>(null)
  const [trainerFromContext, setTrainerFromContext] = useState<Trainer | undefined>()

  const openTrainer = useCallback((trainerId: string, trainer?: Trainer): void => {
    setOpenTrainerId(trainerId)
    setTrainerFromContext(trainer)
  }, [])

  const closeTrainer = useCallback((): void => {
    setOpenTrainerId(null)
    setTrainerFromContext(undefined)
  }, [])

  const value: TrainerModalContextValue = {
    openTrainerId,
    trainerFromContext,
    openTrainer,
    closeTrainer,
  }

  return <TrainerModalContext.Provider value={value}>{children}</TrainerModalContext.Provider>
}
